/**
 * Single-job polling hook (T027). Polls on POLL_ACTIVE_MS while active; stops on
 * terminal; backs off on 429. `isActive(undefined)=true` → the first fetch runs
 * even before data lands.
 */
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { getJob } from '../lib/endpoints/jobs'
import { qk } from '../lib/queryKeys'
import { isActive } from '../lib/jobStatus'
import { pollInterval, POLL_ACTIVE_MS } from '../lib/pollBackoff'

export function useJob(id: string) {
  return useQuery({
    queryKey: qk.job(id),
    queryFn: () => getJob(id),
    enabled: !!id,
    refetchInterval: (query) =>
      pollInterval(
        query.state.error,
        isActive(query.state.data) && POLL_ACTIVE_MS,
      ),
    staleTime: 2500,
    placeholderData: keepPreviousData,
    // Inherit the client defaults (retry skips 4xx, no refetch-on-focus). The
    // 3s poll already recovers from a transient 429 without extra bursts.
  })
}
